const thirdPartyTelematicsDeviceType = ['scania-telematics', 'webfleet-retrofit', 'cargobull', 'krone'];

export function isThirdPartyTelematicsDeviceType(deviceType: string | null | undefined): boolean {
    return typeof deviceType === 'string' && thirdPartyTelematicsDeviceType.includes(deviceType);
}
